module.exports = __webpack_public_path__ + "img/dea-formazione-ico-scienze-motorie.5986c1ff.svg";